export function setupDeviceTabSelectors(userPermissions, device, group, deviceLayout, tab_index = false) {
    var user_tabs = {};
    var index_counter = 0;

    var available_tabs = ["overview", "liveview", "generate_report", "camera_feed", "campaigns", "statistics", "events", "history", "settings"];

    var device_modules = userPermissions.filter(p => p.startsWith('dev_tab:'));

    for (var aTab of available_tabs) {
        let key = "";
        aTab.split("_").forEach((row) => {
            key = key + row.charAt(0).toUpperCase() + row.substring(1) + " ";
        });

        key = key.trim();

        user_tabs[key] = {
            index: index_counter++,
            label: key,
            showing: false
        };

        if (device_modules.find(t => t.includes(aTab))) {
            user_tabs[key].showing = true;
        }
    }


    if (device.module_type == 'clearways' && group?.type != 'clearways') {
        user_tabs['Generate Report'].showing = false;
    }

    if (device.hardware_type != 'bk-camera') {
        user_tabs['Camera Feed'].showing = false;
    }
    else {
        user_tabs['Campaigns'].showing = false;
    }

    if (!device.hardware_type.includes("bk")) {
        user_tabs['Statistics'].showing = false;
        user_tabs['Events'].showing = false;
    }

    if (deviceLayout != 'mobile') {
        user_tabs['Liveview'].showing = false;
    }

    const shown_tabs = Object.values(user_tabs).filter(tab => tab.showing);

    if (tab_index) {
        if (user_tabs?.[tab_index] && user_tabs[tab_index].showing) {
            return user_tabs[tab_index].index;
        }

        return -1;
    }

    return shown_tabs;
}

export function setupGroupTabSelectors(userPermissions, group, tab_index = false) {
    var group_modules = userPermissions.filter(p => p.startsWith('grp_tab:'));

    if (group.type == "clearways" && group.name != "Fitzroy St") {
        group_modules = group_modules.filter(m => !m.includes('camera_feeds'));
    }

    const shown_tabs = group_modules.map(m => {
        let base_text = m.replace("grp_tab:", "");
        let new_tab = "";

        base_text.split("_").forEach((row) => {
            new_tab = new_tab + row.charAt(0).toUpperCase() + row.substr(1) + " ";
        });

        return new_tab.trim();
    });

    return tab_index ? shown_tabs.indexOf(tab_index) : shown_tabs;
}

export function getUserMenuItems(userPermissions) {
    return userPermissions.filter(r => !r.includes(':'));
}

export function getUserSettingsItems(userPermissions, tab) {
    if (userPermissions.length) {
        if (userPermissions.indexOf(tab.id) >= 0) {
            return true;
        }
    }

    return false;
}